import videojs from 'video.js';
import './plugin.css';

const VERSION = '3.0.4';
const Plugin = videojs.getPlugin('plugin');
const Component = videojs.getComponent('Component');

class Simplestream extends Plugin {

    constructor(player) {

        super(player);

        this.embedCode = document.getElementById(this.player.id_).parentNode.parentNode;

        var $_GET=[];
        window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi,function(a,name,value){$_GET[name]=value;});
        this.player.options.getParams = Object.assign({}, $_GET);

        this.log('Simplestream Media Player v' + VERSION);
        this.log('video.js Version ' + videojs.VERSION);

        this.checkAttributes();

    }

    checkAttributes() {

        this.data = this.embedCode.dataset;
        this.data.platform = this.detectPlatform();

        // Check for required data attributes
        var requiredDataAttributes = ['id', 'type', 'key', 'token', 'expiry', 'uvid'];
        for (var i = 0; i < requiredDataAttributes.length; ++i) {
            if (!(requiredDataAttributes[i] in this.data)) {
                return this.errorScreen('Embed Code is missing the "' + requiredDataAttributes[i] + '" attribute.');
            }
        }

        // Validate optional env attribute
        if(!['production', 'staging'].includes(this.data.env)) {
            this.data.env = 'production';
        }

        // Validate type
        if(this.data.type == 'vod') {
            this.data.type = 'show';
        }

        // Validate userid
        if(!this.data.userid) {
            this.data.userid = null;
        }

        // Validate countryCode
        if(!this.data.country) {
            this.data.country = null;
        }

        if(this.data.poster) {
            this.player.poster(this.data.poster);
        }

        this.log(JSON.stringify(this.data, undefined, 2));

        this.getPlayer();
    }

    detectPlatform() {
        
        var ua = window.navigator.userAgent;
            
        // Opera 8.0+
        var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
        
        // Firefox 1.0+
        var isFirefox = typeof InstallTrigger !== 'undefined';
        
        // Safari 3.0+ "[object HTMLElementConstructor]" 
        var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
            
        // Internet Explorer 6-11
        var isIE = /*@cc_on!@*/false || !!document.documentMode;
        
        // Edge 20+
        var isEdge = !isIE && !!window.StyleMedia;
        
        // Chrome 1 - 79
        var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
        
        // Edge (based on chromium) detection
        var isEdgeChromium = isChrome && (navigator.userAgent.indexOf("Edg") != -1);
        
        // Safari iOS
        var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
        var webkit = !!ua.match(/WebKit/i);
        var iOSSafari = iOS && webkit && !ua.match(/CriOS/i);
        
        // Chrome iOS
        var iOSChrome = !!ua.match(/CriOS/i);
        var isAndroidChrome = ua.match(/Chrome\/[.0-9]*/i);
        
        var platform = false;
        if(isSafari || iOSSafari) {
            var platform = 'safari';
        } else if(isFirefox) {
            var platform = 'firefox';
        } else if(iOSChrome) {
            var platform = 'chrome';
        } else if(isChrome || isEdgeChromium || isAndroidChrome) {
            var platform = 'chrome';
        } else if(isEdge) {
            var platform = 'edge';
        } else {
            
            var isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
                navigator.userAgent &&
                navigator.userAgent.indexOf('CriOS') == -1 &&
                navigator.userAgent.indexOf('FxiOS') == -1;
            
            if(isSafari) {
                var platform = 'safari';
            } else {
                var platform = 'unknown';	
            }
            
        }
    
        return platform;
    
    }

    getPlayer() {

        var url = 'https://mm-v2.simplestream.com/ssmp/api.php?id=' + this.data.id + '&env=' + this.data.env;

        this.log('Player API: ' + url);

        fetch(url, {
            method: 'get',
        }).then((response) => {
            return response.json();
        }).then((json) => {

            this.playerApiResponse = json.response;
            this.log('Player API Response:\n' + JSON.stringify(this.playerApiResponse, undefined, 2));

            // Load Google IMA SDK
            if(this.playerApiResponse.ads == 'google') {
                this.importer.url('https://imasdk.googleapis.com/js/sdkloader/ima3.js').then(() => {
                    this.getConsent();
                }).catch(error => this.errorScreen('Please Disable Your Ad Blocker To Watch This Video'));
            } else {
                this.getConsent();
            }

            // Set videojs options
            this.player.preload('auto');
            if(this.playerApiResponse.settings_autoplay == '1') {
                this.player.autoplay('any');
            }
            if(this.playerApiResponse.settings_controls == '1') {
                this.player.controls(true);
            }
            if(this.playerApiResponse.settings_muted == '1') {
                this.player.muted(true);
            }
            console.log('Apply videojs options', this.player.options);

        }).catch((error) => {
            return this.errorScreen('Failed To Fetch Player Config');
        });

    }

    getConsent() {

        this.log('Consent API');

        if (typeof __tcfapi !== 'undefined') {

            console.log('__tcfapi is defined.');

            if (typeof window._sp_.version !== 'undefined') {
                console.log('window._sp_.version is defined.');
                __tcfapi('getTCData', 2, (tcData, success) => {
                    if(success) {
                        this.getStream(1, tcData.tcString);
                    } else {
                        console.log('getTCData failed');
                    }
                });
            } else {
                console.log('window._sp_.version not defined.');
                this.getStream(1, null);
            }
        } else {
            console.log('__tcfapi is not defined.');
            this.getStream(1, null);
        }

    }

    getStream(gdpr, gdpr_consent) {

        var url = this.playerApiResponse.api_hostname + '/streams/api/' + this.data.type + '/stream/' + this.data.uvid +
            '?key=' + this.data.key +
            '&cc=' + this.data.country +
            '&platform=' + this.data.platform +
            '&autoplay=' + this.playerApiResponse.settings_autoplay +
            '&muted=' + this.playerApiResponse.automute +
            '&url=' + encodeURIComponent(window.location.href) +
            '&gdpr=' + gdpr +
            '&gdpr_consent=' + gdpr_consent;

        this.log('Streams API: ' + url);

        fetch(url, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Token': this.data.token,
                'Token-Expiry': this.data.expiry,
                'Userid': '123456',
                'Uvid': this.data.uvid,
            }
        }).then((response) => {
            return response.json();
        }).then((json) => {
            this.streamsApiResponse = json.response;
            this.log('Streams API Response:\n' + JSON.stringify(this.streamsApiResponse, undefined, 2));
            if(this.streamsApiResponse.error) {
                return this.errorScreen('Streams API / ' + this.streamsApiResponse.error);
            } else {
                this.getAnalytics();
            }
        }).catch((error) => {
            return this.errorScreen('Failed To Connect To Streams API');
        });

    }

    getAnalytics() {

        var url = 'https://api' + ((this.data.env == 'staging') ? '-staging' : '') + '.simplestreamcdn.com/analytics/v1/' + this.playerApiResponse.company_uuid + '/analytics';

        if(this.streamsApiResponse.drm
            && this.streamsApiResponse.drm.widevine) {
            var contentResource = this.streamsApiResponse.drm.widevine.stream;
        } else {
            var contentResource = this.streamsApiResponse.stream;
        }

		var postBody = {
	    	"user": this.data.userid,
	    	"content_resource" : contentResource,
	    	'content_contracted_resolution' : Math.ceil(this.player.videoWidth()) + 'x' + Math.ceil(this.player.videoHeight()),
	    	"cc" : this.data.country,
	    	"lang" : 'en',
	    	"region_code" : null,
	    	"stream_type" : this.data.type,
	    	'download' : '0',
	    	'device' : 'web',
	    	'app_name' : (typeof this.playerApiResponse.company_name !== 'undefined') ? this.playerApiResponse.company_name : null,
	    	'platform' : 'web',
	    	'app_release_version' : 'ssmp-' + VERSION,
	    	'unique_video_id' : this.data.uvid,
	    };

        this.log('Analytics API: ' + url + '\n' + JSON.stringify(postBody, undefined, 2));

        fetch(url, {
            method: 'post',
            body: JSON.stringify(postBody),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-api-key': this.data.key,
            },
        }).then((response) => {
            return response.json();
        }).then((json) => {

            // BUGFIX: Needs to be fixed on Analytics API
            delete json.username;
            json['user.name'] = null;

            if (typeof this.data.analytics !== "undefined") {
                let analytics = JSON.parse(this.data.analytics);
                console.log('TEST', analytics);
                if (typeof analytics.usertype !== "undefined") {
                    json['content.customDimension.5'] = analytics.usertype;
                }
                if (typeof analytics.userid !== "undefined") {
                    json['user.name'] = analytics.userid;
                }
            }

            this.analyticsApiResponse = json;
            this.log('Analytics API Response:\n' + JSON.stringify(this.analyticsApiResponse, undefined, 2));
            this.ready();

        }).catch((error) => {
            //return this.errorScreen('Failed To Connect To Analytics API');
        });   

    }

    ready() {

        // Custom TVSN overlay
        if(this.playerApiResponse.company_id == 186) {
            class overlay extends Component {
                constructor(player, options) {
                    super(player, options);
                    videojs.dom.emptyEl(this.el());
                    videojs.dom.appendContent(this.el(), options.text);
                    this.el().onclick = function () { 
                        fetch('https://api.simplestreamcdn.com/proxy/product/v1/buy/vod2live/' + options.uvid + '?cc=au&lang=en', {
                            method: 'get'
                        }).then((response) => {
                            return response.json();
                        }).then((json) => {
                            console.log(json);
                            if(!json.buyNowUrl) {
                                alert('Buy Now URL Not Defined');
                            } else {
                                parent.openTvsnUrl(json.buyNowUrl);
                            }
                        }).catch((error) => {
                            alert('Buy Now Failed');
                        });
                    };
                }
                createEl() {
                    return videojs.dom.createEl('div', {
                        className: 'vjs-overlay vjs-overlay-bottom-right'
                    });
                }
            };
            videojs.registerComponent('overlay', overlay);
            this.player.addChild('overlay', { 
                text: 'Buy Now',
                uvid: this.data.uvid,
            });

        }

        this.player.trigger('simplestream-ready', {
            attributes: Object.assign({}, this.data),
            analyticsApiResponse: this.analyticsApiResponse,
            playerApiResponse: this.playerApiResponse,
            streamsApiResponse: this.streamsApiResponse,
        });

    }

    log(msg) {
        console.log(this.embedCode.id + ' - ' + msg);
    }

    debug(msg) {

        if(this.player.options.getParams.debug) {

            if(!this.embedCode.querySelector('.simplestream-debug')) {
                const debug = document.createElement('div');
                debug.classList.add('simplestream-debug');
                this.embedCode.appendChild(debug);
            }

            const p = document.createElement('p');
            p.innerText = msg;
            this.embedCode.querySelector('.simplestream-debug').appendChild(p);

        }
    }

    errorScreen(msg) {

        class errorBox extends Component {
            constructor(player) {
                super(player);
            }
            createEl() {
                return videojs.dom.createEl('div', {
                    className: 'vjs-error-box'
                });
            }
            updateTextContent(msg) {
                videojs.dom.emptyEl(this.el());
                videojs.dom.appendContent(this.el(), videojs.dom.createEl('img', {}, {
                    src: 'data:image/svg+xml;utf8;base64,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'
                }));
                videojs.dom.appendContent(this.el(), videojs.dom.createEl('p', {}, {}, msg));
            }
        };

        videojs.registerComponent('errorBox', errorBox);

        this.player.addChild('errorBox').updateTextContent(msg);

    }

    importer = {
        url: (url) => {
            return new Promise((resolve, reject) => {
                let script = document.createElement('script');
                script.type = 'text/javascript';
                script.src = url;
                script.addEventListener('load', () => resolve(script), false);
                script.addEventListener('error', () => reject(script), false);
                document.body.appendChild(script);
            });
        },
        urls: (urls) => {
            return Promise.all(urls.map(importer.url));
        }
    };
}

Simplestream.defaultState = {};
Simplestream.VERSION = VERSION;
videojs.registerPlugin('Simplestream', Simplestream);
export default Simplestream;
